module.exports = __webpack_public_path__ + "bc0d8e55bc8608d2cdd91ebd3fe23d13.jpg";